import { Dataset, Iuser, Result, VersionUsage } from '@/typings';
import { get, handleResult, post } from '@/util';
import { isNotEmpty } from '@qsxy/element-plus-react';

// interface LoginData {
// 	user: Iuser;
// 	user_menus: any[];
// 	button_permissions: string[];
// }

export type WechatResult = {
	openId: string;
	sceneStr: string;
	expire: number;
	ticket: string;
	url: string;
};

/**
 * 登录
 * @returns
 */
export function login(params: { username: string; password: string }) {
	return new Promise<any>((resole, reject) => {
		post(
			'/auth/login/username-password',
			params,
			(result: Result<null>) => {
				handleResult(
					result,
					({ data }) => {
						resole({ msg: '登录成功！', data });
					},
					({ message }) => reject({ message }),
				);
			},
			msg => {
				reject({ msg });
			},
			true,
		);
	});
}

/**
 * 校验登录
 * @returns
 */
export function validateToken() {
	return new Promise<{ user: Iuser; data: Record<string, string> }>((resole, reject) => {
		post(
			'/auth/user/validateLogin',
			{},
			(result: Result<{ user: Iuser; data: Record<string, string> }>) => {
				handleResult<any>(
					result,
					({ user, data }) => {
						if (isNotEmpty(user)) {
							resole({ user, data });
						} else {
							reject();
						}
					},
					() => {
						reject();
					},
				);
			},
			() => {
				resole({} as any);
				// reject();
			},
			true,
		);
	});
}

/**
 * 获取版本用量
 * @returns
 */
export function getVersionsUsage(params: { user: string }) {
	return new Promise<VersionUsage>((resole, reject) => {
		get(
			'/version-usage/validateUsage',
			params,
			(result: Result<VersionUsage>) => {
				handleResult<VersionUsage>(
					result,
					({ data }) => {
						if (isNotEmpty(data)) {
							resole(data);
						} else {
							reject();
						}
					},
					() => {
						reject();
					},
				);
			},
			() => {
				resole({} as VersionUsage);
				// reject();
			},
			true,
		);
	});
}

/**
 * 获取知识库ID
 * @returns
 */
export function getDatasetId(params: { user: string }) {
	return new Promise<string>((resole, reject) => {
		get(
			'/dataset/listByUser',
			params,
			(result: Result<Dataset[]>) => {
				handleResult<Dataset[]>(
					result,
					({ data }) => {
						if (isNotEmpty(data) && data.length > 0) {
							resole(data[0].id);
						} else {
							resole('');
						}
					},
					() => {
						reject();
					},
				);
			},
			() => {
				resole('');
				// reject();
			},
			true,
		);
	});
}

/**
 * 验证码登录
 * @returns
 */
export function loginByPhone(params: { type: string; identifier: string; code: string }) {
	return new Promise<any>((resole, reject) => {
		post(
			'/auth/verify-code',
			params,
			(result: Result<null>) => {
				handleResult(
					result,
					({ data }) => {
						resole({ msg: '登录成功！', data });
					},
					({ message }) => reject({ message }),
				);
			},
			msg => {
				reject({ msg });
			},
			true,
		);
	});
}

/**
 * 发送邀请邮件
 * @returns
 */
export function sendShareEmail(params: { email: string; userName: string }) {
	return new Promise<string>((resole, reject) => {
		post(
			'/share/sendShareEmail',
			params,
			(result: Result<string>) => {
				handleResult(
					result,
					({ data }) => {
						resole(data);
					},
					() => reject('邮件发送失败'),
				);
			},
			msg => {
				reject({ msg });
			},
			true,
		);
	});
}

/**
 * 发送邀请邮件
 * @returns
 */
export function getWechatUrl() {
	return new Promise<WechatResult>((resole, reject) => {
		post(
			'/auth/getTicket',
			{},
			(result: Result<WechatResult>) => {
				handleResult(
					result,
					({ data }) => {
						resole(data);
					},
					() => reject('邮件发送失败'),
				);
			},
			msg => {
				reject({ msg });
			},
			true,
		);
	});
}

export function monitorWechat(sceneStr: string) {
	return new Promise<any>((resole, reject) => {
		post(
			'/auth/monitor',
			{ code: sceneStr },
			(result: Result<WechatResult>) => {
				const { code, data } = result;
				if (code === 200) {
					resole?.({ ...data, status: code });
				} else if (code === 500) {
					// 未扫描
					resole(null);
				} else if (code === 404) {
					// 用户未注册或未绑定该微信号
					resole?.({ ...data, status: code });
				}
			},
			msg => {
				reject({ msg });
			},
			true,
		);
	});
}

export function bindWechatId(params: { username: string; wechatId: string }) {
	return new Promise<any>((resole, reject) => {
		post(
			'/auth/bindWechatId',
			params,
			(result: Result<null>) => {
				handleResult(
					result,
					({ data }) => {
						resole({ msg: '登录成功！', data });
					},
					({ message }) => reject({ message }),
				);
			},
			() => {
				resole(false);
			},
			true,
		);
	});
}
